export const LOGIN_ATTEMPT = 'LOGIN_ATTEMPT';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const RESET_LOGIN_ERR = 'RESET_LOGIN_ERR';
export const VALIDATE_VOUCHER = 'VALIDATE_VOUCHER';
export const VOUCHER_ERROR = 'VOUCHER_ERROR';
export const VOUCHER_SUCCESS = 'VOUCHER_SUCCESS';
export const REFRESH_CAPTCHA = 'REFRESH_CAPTCHA';
export const RESET_CAPTCHA = 'RESET_CAPTCHA';
export const FORGOT_PWD = 'FORGOT_PWD';
export const FORGOT_SUCCESS = 'FORGOT_SUCCESS';
export const FORGOT_ERROR = 'FORGOT_ERROR';
export const RESET_FORGET_MSG = 'RESET_FORGET_MSG';
export const GET_CAPTCHA_VALUE = 'GET_CAPTCHA_VALUE';
export const CAPTCHA_ERROR = 'CAPTCHA_ERROR';
export const GET_VALUE = 'GET_VALUE';
export const CAPTCHA_VALIDATION = 'CAPTCHA_VALIDATION';

